export default class Navigation {
  navId: string
  navmenuId: string
  humId: string
  linkSelector: string
  html: HTMLElement
  body: HTMLElement
  pcSizeFlag: boolean
  timeoutId: any
  nav: HTMLElement | null
  hum: HTMLElement | null
  link: NodeListOf<HTMLElement> | null
  breakPoint: number
  pcNavigation: boolean

  constructor(config: {
    navId?: string
    humId?: string
    linkSelector?: string
    breakPoint?: number
    pcNavigation?: boolean
  }) {
    this.navId = config.navId || 'site_navigation'
    this.navmenuId = 'nav_menu'
    this.humId = config.humId || 'hum_toggle'
    this.linkSelector = config.linkSelector || `#${this.navId} a`
    this.pcSizeFlag = false
    this.breakPoint = config.breakPoint || 1025
    this.pcNavigation = config.pcNavigation ?? true

    // HTMLElmentの取得
    this.html = document.documentElement
    this.body = document.body
    this.nav = document.getElementById(this.navId)
    this.hum = document.getElementById(this.humId)
    this.link = document.querySelectorAll<HTMLElement>(this.linkSelector)

    if (!this.nav) console.warn(`ID：${this.navId}が存在しません`)
    if (!this.hum) console.warn(`ID：${this.humId}が存在しません`)
    if (this.link.length <= 0)
      console.warn(`SELECTOR：${this.linkSelector}が存在しません`)

    // 初期処理
    this.addClassNavMenu()
    this.pcSizeFlag = this.widWatch()

    // イベントリスナー
    this.hum?.addEventListener('click', (e) => this.humToggleEvent(e))

    this.link.forEach((elm) => {
      elm.addEventListener('click', (e) => this.humCloseEvent(e))
    })

    window.addEventListener('resize', () => this.resizeEvent(), false)
  }

  humToggleEvent(e: MouseEvent) {
    console.log(!this.pcNavigation, this.pcSizeFlag)
    if (!this.pcNavigation && this.pcSizeFlag) return
    console.log('humToggleEvent')
    e.preventDefault()
    this.hum?.classList.toggle('active')
    this.nav?.classList.toggle('active')
    this.body.classList.toggle('hum_active')
    this.html.classList.toggle('hum_active')
  }
  humCloseEvent(e: MouseEvent) {
    this.hum?.classList.remove('active')
    this.nav?.classList.remove('active')
    this.body.classList.remove('hum_active')
    this.html.classList.remove('hum_active')
  }

  linkClickEvent() {
    if (!this.link) return
    this.link.forEach((elm) => {
      elm.addEventListener('click', this.humCloseEvent)
    })
  }

  resizeEvent() {
    this.pcSizeFlag = this.widWatch()
    this.body.setAttribute('id', 'preload')
    clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(function () {
      if (document.body.id === 'preload') {
        document.body.removeAttribute('id')
      }
    }, 500)
  }

  widWatch() {
    // ウィンドウサイズがPC用のサイズならtrue、それ以下ならfalseを返す
    const wid = window.innerWidth
    if (wid >= this.breakPoint) {
      return true
    } else {
      return false
    }
  }

  addClassNavMenu() {
    const siteNavigation = document.getElementById(this.navId)
    const menu = siteNavigation?.getElementsByTagName('ul')[0]
    if (!menu?.classList.contains(this.navmenuId)) {
      menu?.classList.add(this.navmenuId)
    }
  }
}
